// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"18":"iframe-lazy","525":"choices","801":"fancybox","979":"swiper"}[chunkId] + "." + {"18":"4804a4f317e0b2c8de65","525":"f3839fc0d8c7f8bfd474","801":"80807f741abb54812699","979":"3039878798d35dd4bc09"}[chunkId] + ".js";
};